import { isBrowser } from 'utils/environment';

export const getElementHeight = (id: string) => {
  let elementHeight = 0;

  if (isBrowser) {
    const contentsBounding = window.document
      ?.getElementById(id)
      ?.getBoundingClientRect();

    elementHeight = contentsBounding?.height || 0;
  }

  return elementHeight;
};
